import { cloneGraphNodes } from '../graph/nodeDefs.js';
import type { GraphEdge, GraphNode } from '../graph/nodeDefs.js';
import type { Scene } from '../scene/sceneState.js';
import { vec2Clone } from '../scene/layoutMath.js';
import type { EditorContext } from '../state/appState.js';

export function cloneNodes(nodes: GraphNode[]): GraphNode[] {
  return cloneGraphNodes(nodes);
}

export function cloneEdges(edges: GraphEdge[]): GraphEdge[] {
  return edges.map(edge => ({ ...edge }));
}

export function cloneScene(scene: Scene): Scene {
  const nodes: Scene['nodes'] = {};
  for (const [id, node] of Object.entries(scene.nodes)) {
    const transform = {
      position: vec2Clone(node.position),
      scale: vec2Clone(node.scale),
      origin: vec2Clone(node.origin),
    };
    if (node.kind === 'frame') {
      nodes[id] = { ...node, ...transform, childIds: [...node.childIds] };
    } else {
      // InstanceNode and LayerNode both have paramOverrides
      nodes[id] = { ...node, ...transform, paramOverrides: { ...node.paramOverrides } };
    }
  }
  return {
    rootIds: [...scene.rootIds],
    nodes,
  };
}

export function cloneEditorContext(editorContext: EditorContext): EditorContext {
  return { ...editorContext };
}
